import { GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import BooleanAsYesNoCell from "../../Grid/BooleanAsYesNoCell";
import { columnForField, defaultColumnWidth } from "../../Grid/columnForField";
import { kendoDateCell } from "../../Layout/Grid/Cell/DateCell";
import {
  controlDepartmentTypeColumnMenu,
  controlDepartmentTypeEnumCell,
} from "./ControlDepartmentTypeGridColumn";
import { FtlRoute } from "./FtlRoute";
import { routeStateTypeColumnMenu, routeStateTypeEnumCell } from "./RouteStateTypeGridColumns";
import { YesNoColumnMenu } from "../../Layout/Grid/Filter/YesNoColumnMenu";
import { GRID_SELECTED_FIELD } from "../../Grid/Selectable/GridSelection";
import { MultiSelectCheckboxProps } from "../../Grid/Selectable/MultiSelectCheckboxProps";

export const FtlRouteGridColumns = ({ dataResult, selectedState }: MultiSelectCheckboxProps) => {
  const booleanYesNoCell = (props: GridCellProps) => BooleanAsYesNoCell({ ...props });

  return [
    <GridColumn
      key="SelectHeader"
      field={GRID_SELECTED_FIELD}
      width="44px"
      filterable={false}
      headerSelectionValue={dataResult.data.findIndex((item) => !selectedState[item.Id]) === -1}
    />,
    columnForField<FtlRoute>("RouteNumber", {
      title: "Route Number",
      width: defaultColumnWidth,
    }),
    columnForField<FtlRoute>("Destination", { width: "300px" }),
    columnForField<FtlRoute>("TrailerType", {
      title: "Trailer Type",
      width: defaultColumnWidth,
    }),
    columnForField<FtlRoute>("LaunchClassification", {
      title: "Launch Classification",
      hideFilterCell: true,
      columnMenu: controlDepartmentTypeColumnMenu,
      cell: controlDepartmentTypeEnumCell,
      width: defaultColumnWidth,
    }),
    columnForField<FtlRoute>("ControlType", {
      title: "Control Type",
      width: defaultColumnWidth,
    }),
    columnForField<FtlRoute>("CarrierName", {
      title: "Carrier Name",
      width: "200px",
    }),
    columnForField<FtlRoute>("IsSharedClosedLoop", {
      title: "Shared Closed Loop",
      cell: booleanYesNoCell,
      hideFilterCell: true,
      columnMenu: YesNoColumnMenu,
      width: defaultColumnWidth,
    }),
    columnForField<FtlRoute>("LaunchDate", {
      title: "Launch Date",
      filter: "date",
      width: "220px",
      cell: kendoDateCell(),
    }),
    columnForField<FtlRoute>("ReturnLaunchDate", {
      title: "Roundtrip RT-Leg Start Date",
      filter: "date",
      width: "220px",
      cell: kendoDateCell(),
    }),
    columnForField<FtlRoute>("Status", {
      hideFilterCell: true,
      columnMenu: routeStateTypeColumnMenu,
      cell: routeStateTypeEnumCell,
      width: defaultColumnWidth,
    }),
    columnForField<FtlRoute>("Alert", {
      title: "Project Alert",
    }),
  ];
};
